import { Order } from './order.model';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({providedIn: 'root'})
export class OrderService extends BaseService<Order> {

  constructor(
      protected injector:Injector,
  ){
      super(injector);
      this.copyJsonDataToObjectFunction=Order.fromJsonToObject
      this.urls={getAllUrl:'orders',statusUrl:'order-status'}
  }

}
